<template>
  <div>
    <div
      v-for="(item, index) in model"
      :key="index"
      class="rounded p-3 bg-gray my-3"
    >
      <div class="row">
        <div class="col-12 col-md">
          <div class="data-name">Tipo de Documento:</div>
          <div>{{ item.documentType.name | empty }}</div>
        </div>
        <div v-if="isItemOther(item.documentType.id)" class="col-12 col-md">
          <div class="data-name">Título del Documento:</div>
          <div>{{ item.other | empty }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="data-name">Archivo:</div>
          <div>{{ documentName(item) | empty }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="d-flex justify-content-end mt-1">
            <action-button
              v-if="!isReadOnly"
              i="fas fa-times-circle"
              variant="outline-danger mr-2"
              @click="remove(index)"
            />
            <action-button
              i="fas fa-file-download"
              variant="success"
              @click="download(item)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="canAdd" :class="addVariant">
      <validation-observer ref="documentsForm" v-slot="{ failed }" novalidate>
        <div class="row">
          <div class="col-12 col-md">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="innerModel.documentType"
                :class="{
                  'was-Invalidated-select': !!errors[0],
                }"
                custom-error-msg="El campo es requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Documento:"
                :options="documentTypes"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div v-if="isOther" class="col-12 col-md">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="innerModel.other"
                custom-error-msg="El campo es requerido."
                :error="errors[0]"
                label="Nombre del Documento:"
              />
            </validation-provider>
          </div>
          <div
            class="col-12"
            :class="{ 'col-md-5': !isOther, 'col-md-4': isOther }"
          >
            <div class="data-name mb-2">
              Archivo:
            </div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-file-input
                ref="fileUpload"
                v-model="innerModel.file"
                :accept="allowedFiles"
                custom-error-msg="El documento es requerido"
                display-style="normal"
                :error="errors[0]"
                :max-size="10"
                :on-download="() => {}"
              />
            </validation-provider>
          </div>
          <div
            class="col-12 col-md-3 d-flex justify-content-center align-items-center"
            :class="{
              'pt-4': !failed,
            }"
          >
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-2"
              @click="cancel"
            />
            <action-button
              i="fas fa-save"
              text="Añadir"
              variant="success"
              @click="save"
            />
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-else-if="!isReadOnly" class="d-flex justify-content-end">
      <action-button
        i="fas fa-file-plus"
        text="Añadir"
        variant="success"
        @click="showAdd = true"
      />
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixin/alert.mixin';

import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';

import generalApi from '@/services/pei/general';

import DocumentTypes from '@/utils/constants/documentTypes';

export default {
  name: 'Documents',
  components: {
    ValidationProvider,
    CustomInput,
    CustomDropDown,
    CustomFileInput,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    documentTypes: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    otherTypeId: {
      type: Number,
      default: () => DocumentTypes.TapAlternativeLocationDocument,
    },
    addVariant: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      innerModel: {},
      showAdd: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    canAdd() {
      return !this.isReadOnly && (this.showAdd || !this.model.length);
    },
    allowedFiles() {
      // const values = ['.pdf', '.docx', '.xlsx', '.png'];
      return ['.pdf'].join(',');
    },
    isOther() {
      return this.innerModel.documentType?.id === this.otherTypeId;
    },
    isItemOther() {
      return (id) => id === this.otherTypeId;
    },
    isDuplicateOtherTitle() {
      if (!this.isOther) return false;
      const title = this.innerModel.other.trim().toLowerCase();
      if (!title) return false;
      return this.model.some(
        (x) =>
          x.documentType?.id === this.otherTypeId &&
          x.other.trim().toLowerCase() === title
      );
    },
    documentName() {
      return (item) => (item.id ? item.document.name : item.file.name);
    },
  },
  methods: {
    clear() {
      this.innerModel = {};
      this.$refs.documentsForm.reset();
      this.$refs.fileUpload.removeFile();
      this.cancel();
    },
    cancel() {
      this.showAdd = false;
    },
    async save() {
      const isValid = await this.$refs.documentsForm.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Debe indicar el tipo y seleccionar un archivo válido para continuar.',
          'error'
        );
        return;
      }

      if (this.isDuplicateOtherTitle) {
        this.ShowToast(
          '',
          'Ya existe un documento “Otro” con ese mismo título.',
          'error'
        );
        return;
      }
      this.model.push({
        documentType: this.innerModel.documentType,
        other: this.innerModel.other,
        file: this.innerModel.file,
      });
      this.clear();
    },
    async remove(index) {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar este documento adjunto?',
        'Si',
        'No'
      );

      if (!confirmed) return;
      this.model.splice(index, 1);
    },
    async download(item) {
      if (item.id)
        await generalApi.downloadDocumentByAttachmentId(item.document.id);
      else generalApi.documentDownloadLocalFile(item.file);
    },
  },
};
</script>
<style scoped>
div.was-Invalidated-select ::v-deep .v-select > div {
  background-color: #f7d7da;
  border: 1px solid #ff0018 !important;
}
::v-deep div.was-Invalidated {
  border: none !important;
}

::v-deep .was-Invalidated.file-input-container {
  border: 1px solid #ff0018 !important;
}
</style>
